// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dots{display:flex}.dots .dots-filled{margin-right:var(--space-2);box-sizing:border-box;width:8px;height:8px;border-radius:50%;background-color:var(--grey-medium)}.dots .dots-outlined{margin-right:var(--space-2);box-sizing:border-box;width:8px;height:8px;border-radius:50%;font-size:var(--font-size-12);border:1px solid var(--grey-light)}\n", ""]);
// Exports
module.exports = exports;
